import imgUrl from './loader-apple.gif';
import useTrackLoader from './useTrackLoader';

/**
 * A loading spinner component that displays an animated GIF.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.height='78'] - Height of the loader image in pixels
 * @param {string} [props.instance] - Unique identifier for tracking loader instances
 * @param {boolean} [props.track=false] - Whether to track loader usage
 * @param {string} [props.width='70'] - Width of the loader image in pixels
 * @returns {JSX.Element} An image element displaying the loading spinner
 */
function Loader({ height = '78', instance, track = false, width = '70' }) {
    useTrackLoader({ enabled: track, instance });

    return <img src={imgUrl} alt="Loading..." width={width} height={height} />;
}

export default Loader;
